/**
 * 파일 타입에 따른 MIME 타입 반환
 * @param fileType 파일 타입
 * @returns MIME 타입 문자열
 */
export const getFileBlobType = (
  fileType: 'text' | 'excel' | 'json' | 'xml' | 'zip' | 'pdf',
): string => {
  switch (fileType) {
    case 'excel':
      return 'application/vnd.ms-excel';
    case 'xml':
      return 'application/xml';
    case 'json':
      return 'application/json;charset=utf-8';
    case 'zip':
      return 'application/zip';
    case 'pdf':
      return 'application/pdf';
    case 'text':
    default:
      return 'text/plain;charset=utf-8';
  }
};

/**
 * URL을 통한 파일 다운로드
 * @param path 다운로드할 파일 경로 또는 URL
 * @param name 저장할 파일명(옵션)
 */
export const downloadByUrl = (path: string, name?: string) => {
  const el = document.createElement('a');
  el.href = path;
  el.download = name ?? path;
  el.style.display = 'none';
  document.body.appendChild(el);
  el.click();
  document.body.removeChild(el);
};

/**
 * Blob 데이터를 파일로 다운로드
 * @param fileName 파일명
 * @param fileData 파일 데이터(Blob 등)
 * @param fileType 파일 타입(기본값: text)
 */
export const fileDownload = ({
  fileName,
  fileData,
  fileType = 'text',
}: {
  fileName: string;
  fileData: BlobPart;
  fileType?: 'text' | 'excel' | 'json' | 'xml' | 'zip' | 'pdf';
}) => {
  const blobType = getFileBlobType(fileType);
  const blob = new Blob([fileData], {
    type: blobType,
  });
  const url = window.URL.createObjectURL(blob);
  downloadByUrl(url, fileName);
  URL.revokeObjectURL(url);
};
